module.exports = __webpack_public_path__ + "files/ffc87cad187a5eb12b88a0b53bc489e6.png";